import styled from 'styled-components';

import { ColorEnum } from '@enum/style/color.enum';

interface WrapperProps {
  isDark?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isDark }) => (isDark ? ColorEnum.Black100 : ColorEnum.Black10)};
`;
